import _ from 'lodash';
import Cookies from 'universal-cookie';

import { ROOT_DOMAIN } from '@/services/connections.service';

const COOKIE_NAME_PREFIX = `H_${String(
  process.env.NEXT_PUBLIC_APP_ENV
).toUpperCase()}_`;

export const COOKIE_MAP = {
  OPS_PORTAL_USER_IDENTITY: `${COOKIE_NAME_PREFIX}OPS_PORTAL_USER_IDENTITY`,
  SELECTED_PLANNER_CART: `${COOKIE_NAME_PREFIX}SELECTED_PLANNER_CART`
};

const isDevelopment = process.env.NEXT_PUBLIC_APP_ENV === 'development';
const defaultCookieOptions = {
  domain: `.${ROOT_DOMAIN}`,
  doNotParse: false,
  maxAge: 1000 * 3600 * 24 * 30,
  path: '/',
  secure: !isDevelopment
};

const cookies = new Cookies(null, defaultCookieOptions);

export const getCookie = ({ name }) => cookies.get(name, defaultCookieOptions);

export const removeCookie = ({ name }) =>
  cookies.remove(name, defaultCookieOptions);

export const setCookie = async ({ name, data }) => {
  if (_.isEmpty(data)) {
    removeCookie({ name });
  } else {
    cookies.set(name, data, defaultCookieOptions);
  }
  return getCookie({ name });
};
